(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.target = null;
      this.targetSelector = this.dataset.observeTarget || 'add-to-cart-component';
    }

    connectedCallback() {
      this.button = this.querySelector('[data-sticky-add-to-cart-button]');
      this.target = document.querySelector(this.targetSelector);
      this.setupObserver();
      this.setupButtonClick();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupObserver() {
      if (!this.target) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Button is visible - hide sticky bar
              this.dataset.visible = 'false';
            } else {
              // Button is not visible - check if we've scrolled PAST it (it's above viewport)
              const rect = this.target.getBoundingClientRect();
              const isAboveViewport = rect.bottom < 0;
              this.dataset.visible = isAboveViewport.toString();
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px'
        }
      );

      this.observer.observe(this.target);
    }

    setupButtonClick() {
      if (!this.button) return;

      this.button.addEventListener('click', () => {
        // Find and click the original add-to-cart button
        const originalButton = document.querySelector('add-to-cart-component [ref="addToCartButton"]');
        if (originalButton) {
          originalButton.click();
        }
      });
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

})();
